import gql from "graphql-tag";

export const GET_ACCOUNTS_BY_USER = gql`
  query {
    getUserAccounts {
      stripe
    }
  }
`;
